import type { WorkspaceAsideConfig } from '@components/v2/layout/AppTemplate/appTemplate.types';
import LangEnum from '../../../lang/LangEnum';
import { RACHEL_PANEL_WIDTH } from '../rachel.layout';
import { useRachelStore } from '../store/rachel.store';
import { selectSetRachelDockedLayout } from '../store/rachel.store.selectors';
import { useIsRachelDocked } from './useIsRachelDocked';

const RACHEL_WORKSPACE_ASIDE_LAYOUT_ID = 'rachel';

export const useRachelWorkspaceAside = (): Omit<WorkspaceAsideConfig, 'panel'> => {
  const isDocked = useIsRachelDocked();
  const setDockedLayout = useRachelStore(selectSetRachelDockedLayout);

  return {
    isOpen: isDocked,
    layoutId: RACHEL_WORKSPACE_ASIDE_LAYOUT_ID,
    minWidth: RACHEL_PANEL_WIDTH,
    resizeLabel: LangEnum.RACHEL_PANEL_RESIZE,
    onSizeChange: setDockedLayout,
  };
};
